const getFormHelperTextProps = (InputProps?: { 'aria-errormessage'?: string }) => {
    return InputProps && InputProps['aria-errormessage']
        ? {
              id: InputProps['aria-errormessage'],
          }
        : undefined;
};
export default getFormHelperTextProps;
